export const h = {
  navMenu: ["HOME","PRE-REGISTRATION", "HEROES", "FEATURES"],
}


// WEBPACK FOOTER //
// ./src/i18n/lan/en.js